<div class="form-field">
  @if (isCheckable()) {
    <fieldset>
      <legend class="form-label" [class.sr-only]="hideLabel()">
        <ng-container *ngTemplateOutlet="labelTemplate" />
      </legend>
      <ng-container *ngTemplateOutlet="contentTemplate" />
    </fieldset>
  } @else {
    <label class="form-label" [class.sr-only]="hideLabel()" [for]="id()">
      <ng-container *ngTemplateOutlet="labelTemplate" />
    </label>
    <ng-container *ngTemplateOutlet="contentTemplate" />
  }

  @if (hintAfter()) {
    <p class="form-hint" [id]="'hintid-' + id()">{{ hintAfter() }}</p>
  }

  @if (showValidationMessages()) {
    <ds-field-error-message [id]="'errorid-' + id()" [errors]="errors()" [label]="label()" />
  }
</div>

<ng-template #labelTemplate>
  {{ label() }}
  @if (!readonly() && required()) {
    <span class="required">*</span>
  }
</ng-template>

<ng-template #contentTemplate>
  <ng-content />
</ng-template>
